import { Shelf } from "../models/Shelf";
import { TreeParameters } from "../models/TreeParameter";
export const TransformDelayModelData = (node: Shelf): TreeParameters => {
  const model: TreeParameters = {
    id: node.TreeId!,
    parent: node.ParentTreeId ? node.ParentTreeId : 0,
    text: node.Title,
    sortOrder: null,
    data: {
      fileType: "csv",
      fileSize: "",
    },
	droppable: node.isLeaf ? false : true,
  };
  return model;
};
